
export enum ErrorMessages {
  requiredField = "This is a required field",
  emailField = "Must be a valid email",
  dateInPastField = "Shouldn't be in the past",
  dateInFutureField = "Shouldn't be in the future",
}
